import { BoxFullWidth, fullWidthStyle } from './full-width';

export const Box = {
  FullWidth: BoxFullWidth
};

export const boxStyles = {
  fullWidth: fullWidthStyle
};
